import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarShow: true,
  theme: "light",
};
export const Slice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    set: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {},
});

export const { set } = Slice.actions;

export default Slice.reducer;
